var lib_core      = require("lib-core");

var SymbolSettingsModel = function (data) {
    ui_extensions.SettingsModel.call(this, data);
};
if(typeof window !== 'undefined') {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(SymbolSettingsModel, ui_extensions.SettingsModel);
}
lib_core.JsonParser.registerClass(SymbolSettingsModel, "SymbolSettingsModel");

module.exports = SymbolSettingsModel;
